module.exports = __webpack_public_path__ + "img/indie-rocks.9a8e1f54.png";